<template>
<div>
<div class="container-spinner">
  
  <div class="placeholder-text">x</div>
   <div ref="placeholder-spinner" class="placeholder-spinner">
		<canvas width="50" height="50" ref="spinner-canvas" class="spinner-canvas rotating"/>
   </div>
   
   
</div>
<div v-if="title" class="loading-text">{{title}}</div>
</div>
</template>

<script>


export default {
  name: 'spinner',
  props:{
	color:{default:"#707070"},
	title:{default:undefined},
  },
  data:function(){
    return {
    }
  },
  components:{
  },
  methods:{
	drawSpinner(){
		var canvas=this.$refs['spinner-canvas'];
		var ph=this.$refs['placeholder-spinner'];

		var width=ph.clientHeight;
		var height=ph.clientHeight;
		
		canvas.style.width=width+"px";
		canvas.style.height=height+"px";


		var canvasWidth=canvas.width;
		//var canvasHeight=canvas.height;

		var ctx=canvas.getContext("2d");
		ctx.beginPath();
		ctx.lineWidth = 3;
		//ctx.lineCap = "round";
		ctx.lineJoin ="round";
		ctx.strokeStyle = this.color;
		var steps=20;
		var pi=((Math.PI*2)*.80)/steps;
		var hWidth=(canvasWidth/2);
		
		var px=Math.sin(0)*(hWidth-(ctx.lineWidth/2));
		var py=Math.cos(0)*(hWidth-(ctx.lineWidth/2));
		ctx.moveTo(hWidth+px,hWidth+py);
		
		for(var i = 1;i<steps;i++){
			var a=1-(1/steps)*i;
			ctx.strokeStyle = this.color
			ctx.globalAlpha = a;
			px=Math.sin(pi*i)*(hWidth-(ctx.lineWidth/2));
			py=Math.cos(pi*i)*(hWidth-(ctx.lineWidth/2));
			
			ctx.lineTo(hWidth+px,hWidth+py);
			ctx.stroke();
		}  
	}
  },
  mounted:function(){
    this.drawSpinner();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container-spinner{
 position:relative;
  width:100%;
  text-align:center;
  font-size:1.5em; /* sets the spinner size */
  padding:0 5px;
}
.loading-text{
	font-size:.6em;
	font-weight:normal;
}
.placeholder-text{
	visibility: hidden;
	display:inline-flex;
}
.placeholder-spinner{
	position:absolute;
	top:0;
	left:50%;
	display:block;
	height:100%;
	display: flex;
    align-items: center;
	
}
.spinner-canvas{
	position:relative;
	top:0;
	left:-50%;
}

@keyframes rotating
	{
	0%
		{
		transform: rotate(-360deg);
		-o-transform: rotate(-360deg);
		-ms-transform: rotate(-360deg);
		-moz-transform: rotate(-360deg);
		-webkit-transform: rotate(-360deg);
		}
	}
@-webkit-keyframes rotating
	{
	0%
		{
		transform: rotate(-360deg);
		-webkit-transform: rotate(-360deg);
		}
	}
.rotating
	{
	-webkit-animation: rotating .75s linear infinite;
	-moz-animation: rotating .75s linear infinite;
	-ms-animation: rotating .75s linear infinite;
	-o-animation: rotating .75s linear infinite;
	animation: rotating .75s linear infinite;
	}


</style>

